import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { useLayout } from '../../../../hooks/screen/useLayout';
import { Section1 } from './components/Section1';
import { Section2 } from './components/Section2';

export const SellTractorSurveyTipPage = () => {
  const navigate = useNavigate();

  useLayout({
    fixedHeader: (
      <HeaderSection>
        <BackButton onClick={() => navigate(-1)}>
          <Icon name={'ArrowLeft'} width={20} height={20} />
        </BackButton>
      </HeaderSection>
    ),
    fixedFooter: (
      <ButtonContainer>
        <BlurredSection />

        <GreyButton onClick={() => navigate(-1)}>
          <GreyButtonText>{'닫기'}</GreyButtonText>
        </GreyButton>
      </ButtonContainer>
    ),
    fixedHeaderHeight: 36,
    fixedFooterHeight: 72,
  });

  return (
    <Container>
      <TopSection>
        <Title>{'트랙터의 정확한 정보와\n직접 촬영한 사진이 필요해요 🤓'}</Title>
        <Description>{'고객님의 트랙터 판매를 위해\n아래와 같은 자료가 필요합니다.'}</Description>
      </TopSection>

      <Section1 />

      <Section2 />
    </Container>
  );
};

const HeaderSection = styled.div`
  width: 100%;
  height: 36px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px 16px;

  gap: 16px;
`;

const BackButton = styled.button``;

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  padding-bottom: 40px;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px var(--radius-large, 16px);
  gap: 32px;
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 512px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0px 16px;
  padding-bottom: 32px;

  gap: 8px;

  background-color: white;

  position: relative;
`;

const BlurredSection = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);

  position: absolute;
  top: -40px;
`;

const GreyButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const DownloadGuideSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  padding: 0px var(--radius-large, 16px) 24px var(--radius-large, 16px);
  gap: 10px;
`;

const DownloadButton = styled.a`
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;

const DownloadIconWrap = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px 3px 3px 3px;
`;

const DownloadButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
